export default __webpack_public_path__ + "static/media/SpotifyClone.c1814611.gif";